var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMassiveCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4518_1370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78196 0V1.61843C12.3028 2.05108 14.797 5.24787 14.3639 8.76515C13.995 11.6815 11.7013 13.997 8.78196 14.3415V15.9439C13.193 15.5033 16.401 11.5934 15.9599 7.18678C15.599 3.38107 12.5754 0.376565 8.78196 0V0ZM7.17795 0.024036C5.61404 0.176264 4.12231 0.777166 2.90326 1.78668L4.05013 2.97246C4.94837 2.25138 6.03108 1.78668 7.17795 1.62644V0.024036V0.024036ZM1.77243 2.91637C0.769649 4.13207 0.152543 5.6189 0 7.18678H1.60401C1.75639 6.04907 2.20551 4.96745 2.9193 4.06209L1.77243 2.91637ZM10.787 5.18378L6.87318 9.09364L5.17293 7.39509L4.32281 8.24437L6.87318 10.7922L11.6371 6.03305L10.787 5.18378ZM0.00802004 8.78918C0.168421 10.3595 0.785965 11.8418 1.78045 13.0596L2.9193 11.9139C2.21107 11.0082 1.75956 9.92897 1.61203 8.78918H0.00802004V8.78918ZM4.05013 13.0916L2.90326 14.1893C4.11812 15.201 5.60543 15.831 7.17795 16V14.3976C6.03701 14.2502 4.95672 13.7992 4.05013 13.0916V13.0916Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4518_1370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMassiveCheck);
export default __webpack_public_path__ + "static/media/icon--massive-check.1a36b27acab4e882e50c80f610dc8b92.svg";
export { ForwardRef as ReactComponent };